export default {
   API_PATH: "api",
   //API_PATH: "http://localhost:8082/",
   WS_PATH: "ws://localhost:8088/currencies/ws"
}
